import React from "react"
import { createContext } from "react"
import Switch from "@mui/material/Switch"
import HomePage from "./components/HomePage"
import Skills from "./components/Skills"
import {
    BrowserRouter as Router,
    Routes,
    Route,
    } from "react-router-dom";

import scrollPercentage from "./main.js"



export const ThemeContext = createContext(null)

export default function App(){
    const [ theme, setTheme ] = React.useState('dark')

    const toggleTheme = ()=>{
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'))
        
    }
    return(
        <Router>
            <ThemeContext.Provider value={{theme, toggleTheme}}>
                <div className="main" id={theme}>

                    <Routes>
                        <Route exact path="/" element={ <HomePage/>} />
                        <Route exact path="/skills" element={ <Skills/>} /> 
                    </Routes>
                    <Switch 
                        className="switch"
                        checked={theme === 'light'}
                        onChange={toggleTheme}
                        size="small"
                        color="secondary"
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                    <div id="progress" className="bg-purple-600">
                        <span id="progress-value" className="text-purple-600"></span>
                    </div>
                </div>
            </ThemeContext.Provider>
        </Router>
    )
}